import React, { useState } from "react"
import APKDropdown from "../../../components/apkDropdown/APKDropdown"
import Alert from "@mui/material/Alert"
import AlertTitle from "@mui/material/AlertTitle"
import Stack from "@mui/material/Stack"
import SyncIcon from "@mui/icons-material/Sync"
import IconButton from "@mui/material/IconButton"
import FormControl from "@mui/material/FormControl"

const AssignAPK = ({
  orgCode,
  isDisabled,
  apkDropdownOnchange,
}) => {
  const [isRefresh, setRefresh] = useState(false)
  const handleRefresh = () => {
    setRefresh(true)
  }
  return (
    <div>
      <Stack spacing={4} sx={{ marginBottom: "150px" }}>
        <Alert severity="info">
          <AlertTitle>Info</AlertTitle>
          Select the APK from the dropdown and click{" "}
          <strong>save to assign it to the selected groups</strong>
        </Alert>
        <br />
        <Stack direction="row" spacing={2}>
          <FormControl fullWidth>
            <APKDropdown
              isRefresh={isRefresh}
              setRefresh={setRefresh}
              orgCode={orgCode}
              isDisabled={isDisabled}
              onChange={apkDropdownOnchange}
            />
          </FormControl>
          <IconButton onClick={handleRefresh}>
            <SyncIcon />
          </IconButton>
        </Stack>
      </Stack>
    </div>
  )
}

export default AssignAPK
